import { Config } from "@/shared/config";

export enum Environment {
  Prod,
  Test,
  Demo,
  ExternalDev
}

export const getEnvironment = (): Environment => {
  if (Config.UserServicebaseUri.indexOf(".bendhsa.com") > 0) return Environment.Prod;
  else if (Config.UserServicebaseUri.indexOf(".bendhsademo.com") > 0) return Environment.Demo;
  else if (Config.UserServicebaseUri.indexOf("api-external.live-test-domain.com") > 0) return Environment.ExternalDev;

  return Environment.Test;
};

export const isProd = (): boolean => {
  return getEnvironment() === Environment.Prod;
};

export const isLocalHost = (): boolean => {
  return window.location.hostname === "localhost";
};